import { Box, Button, Chip, Menu, Stack, Typography } from "@mui/material";
import { Close, FilterList } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { ConvertObjectTranslatedToArray } from "../../../Utils/ConvertObjetctTranslatedToArray";
import {
  CloseButton,
  CollapseContainer
} from "./styles";
import { PixTablesFilter } from "./FilterComponents/PixTablesFilter";
import { ReceiptFilter } from "./FilterComponents/ReceiptsFilter";
import { ExtractFilter } from "./FilterComponents/ExtractFilter";
import { TransfersFilter } from "./FilterComponents/TransfersFilter";
import { TicketsFilter } from "./FilterComponents/TicketsFilter";
import { useFilter } from "../../../Hooks/useFilter";
import { returningObjectWithoutNullProperties } from "../../../Utils/checkObjectProperties";
import { PixTotalsFilter } from "./FilterComponents/PixTotalsFilter";
import { PixStatementFilter } from "./FilterComponents/PixStatementFilter/index";
import { InvoiceFilter } from "./FilterComponents/InvoiceFilter";
import { useSubAccountsList } from "../../../Hooks/useSubAccounts";

interface TableFilterProps {
  tableName:
  | "pixPayment"
  | "pixReceive"
  | "pixTotals"
  | "pixStatement"
  | "receipt"
  | "extract"
  | "refunds"
  | "transfers"
  | "tickets"
  | "invoices"
  | "invoiceBuyers"
  | "invoiceDashboard"
  | "invoiceDuplicates";
  setPageToFirst: (query?: any) => void;
}

export const TableFilter = ({
  tableName,
  setPageToFirst,
}: TableFilterProps) => {
  const [appliedFilters, setAppliedFilters] = useState([] as any);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const { getFilterObj, handleRemoveFilters } = useFilter();
  const filterObj = getFilterObj(tableName) as any;

  const needsSubAccountLookup = ["extract", "transfers", "pixStatement"].includes(tableName);
  const { state: subAccounts, handleGET: fetchSubAccountsGET } = useSubAccountsList();

  useEffect(() => {
    if (needsSubAccountLookup) {
      fetchSubAccountsGET({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [needsSubAccountLookup]);

  const handleOpenMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleRemoveFiltersByTags = (filterName: string) => {
    const newFilterObject = {
      ...filterObj,
      [filterName]: "",
    };

    handleRemoveFilters(tableName, newFilterObject);
    setPageToFirst();
  };

  useEffect(() => {
    const ObjectWithoutNullValues =
      returningObjectWithoutNullProperties(filterObj);
    let tagsFilter = ConvertObjectTranslatedToArray(ObjectWithoutNullValues, tableName);

    if (needsSubAccountLookup && Array.isArray(subAccounts) && filterObj?.sub_account_id) {
      const found = subAccounts.find((sa: any) => sa.subAccountId === filterObj.sub_account_id);
      if (found) {
        tagsFilter = tagsFilter.map((tag: any) => {
          const labelKey = Object.keys(tag)[0];
          const filterKey = Object.keys(tag)[1];
          if (labelKey === "Ponto de venda" && filterKey === "sub_account_id") {
            return { [labelKey]: found.name, [filterKey]: tag[filterKey] };
          }
          return tag;
        });
      }
    }

    setAppliedFilters(tagsFilter);
    handleCloseMenu();
  }, [filterObj]);

  return (
    <Box mb={0}>
      <Box>
        <Stack direction='row' spacing={1} alignItems='center' flexWrap='wrap'>
          <Button
            variant="contained"
            color="primary"
            size="large"
            startIcon={<FilterList />}
            onClick={handleOpenMenu}
            sx={{
              color: '#fff',
              textTransform: 'none',
              fontWeight: 600,
              borderRadius: 1.5,
              px: 3,
              py: 1.25,
              fontSize: 15,
            }}
          >
            Aplicar Filtros
          </Button>

          {(appliedFilters || []).map((filter, i) => (
            <Box
              key={i}
              onClick={e => handleRemoveFiltersByTags(Object.keys(filter)[1])}
              sx={{
                color: '#fff',
                backgroundColor: theme => theme.palette.primary.main,
                px: 1,
                py: .5,
                borderRadius: 1,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                cursor: 'pointer'
              }}
            >
              <Box mr={1}>
                <Typography sx={{ fontSize: 12 }}>{Object.keys(filter)[0]}</Typography>
                <Typography sx={{ fontSize: 10 }}>{Object.values(filter)[0]}</Typography>
              </Box>
              <Close />
            </Box>
          ))}
        </Stack>
      </Box>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleCloseMenu}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <CollapseContainer>
          <CloseButton onClick={() => handleCloseMenu()}>
            fechar <Close />
          </CloseButton>
          {(tableName === "pixPayment" || tableName === "pixReceive") && (
            <PixTablesFilter
              tableName={tableName}
              setPageToFirst={setPageToFirst}
            />
          )}
          {tableName === "pixTotals" && (
            <PixTotalsFilter
              tableName={tableName}
              setPageToFirst={setPageToFirst}
            />
          )}
          {tableName === "pixStatement" && (
            <PixStatementFilter
              tableName={tableName}
              setPageToFirst={setPageToFirst}
            />
          )}
          {tableName === "receipt" && (
            <ReceiptFilter
              tableName={tableName}
              setPageToFirst={setPageToFirst}
            />
          )}
          {(tableName === "extract" || tableName === "refunds") && (
            <ExtractFilter
              tableName={tableName}
              setPageToFirst={setPageToFirst}
            />
          )}
          {tableName === "transfers" && (
            <TransfersFilter
              tableName={tableName}
              setPageToFirst={setPageToFirst}
            />
          )}
          {tableName === "tickets" && (
            <TicketsFilter
              tableName={tableName}
              setPageToFirst={setPageToFirst}
            />
          )}
          {tableName === "invoices" && (
            <InvoiceFilter
              tableName={tableName}
              setPageToFirst={setPageToFirst}
            />
          )}
        </CollapseContainer>
      </Menu>

    </Box>
  );
};
